export type ImageResource = {
  owner: string;
  view: string;
  refs: number;
  controller: AbortController;
  promise: Promise<string>;
  url?: string;
};
export const imageResources = new Map<string, ImageResource>();

export function clearManualImages(owner: string, view?: string) {
  for (const [key, resource] of imageResources) {
    if (resource.owner !== owner || (view && resource.view !== view)) continue;
    resource.controller.abort();
    if (resource.url) URL.revokeObjectURL(resource.url);
    imageResources.delete(key);
  }
}
